export default class Utils {

    static cleanSession() : void{ 
        sessionStorage.clear();
    }
}